import React, { FC } from 'react'
import styles from 'styles/components/form.module.scss'

type Props = {
  onClick: (type: 'order' | 'deliver') => void
  type: string
}

const ToggleSquareButton: FC<Props> = (props) => {
  const { type, onClick } = props

  return (
    <div className={styles.toggle_square}>
      <button
        className={type === 'order' ? styles.toggle_square__button_active : styles.toggle_square__button}
        onClick={() => onClick('order')}
      >
        注文が入った日
      </button>
      <button
        className={type === 'deliver' ? styles.toggle_square__button_active : styles.toggle_square__button}
        onClick={() => onClick('deliver')}
      >
        お客様の受取日
      </button>
    </div>
  )
}

export default ToggleSquareButton
